import MobilePageCover from "components/Common/MobilePageCover/MobilePageCover";
import { Link, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import { ROUTER_PATH } from "config/path";
import { LeftIcon } from "assets/icons";
import InfoListItem from "pages/user/dashboard/detail/InfoListItem";
import styled from "styled-components";
import Button from "components/foundation/Button";
import Toast from "components/foundation/Toast";
import Modal from "components/foundation/Modal/Modal";
import useBeforeUnload from "features/common/hooks/useBeforeUnload";
import SaveWarningModal from "pages/user/dashboard/detail/SaveWarningModal";
import useNoticeUpdateMutation from "features/notice/hooks/mutations/useNoticeUpdateMutation";
import useNoticeQuery from "features/notice/hooks/queries/useNoticeQuery";
const NoticeDashboardEditMobilePage = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { mutate } = useNoticeUpdateMutation();
  const { data } = useNoticeQuery(id as string);
  const noticeDetail = data.data.result.notice;
  const {
    blocking,
    process,
    isBlock,
    enableUnloadTracking,
    disableUnloadTracking,
  } = useBeforeUnload({
    isInitialTracking: false,
  });

  const [nameErrorToastOpen, setNameErrorToastOpen] = React.useState(false);
  const [isConfirmModal, setIsConfirmModal] = React.useState(false);
  const [isNameEmptyOpen, setIsNameEmptyOpen] = React.useState(false);
  const [isContentEmptyOpen, setIsContentEmptyOpen] = React.useState(false);

  const [title, setTitle] = React.useState(noticeDetail.title);
  const [content, setContent] = React.useState(noticeDetail.content);

  const handleSubmit = () => {
    if (title.length < 2) return;
    if (title.length > 100) {
      setNameErrorToastOpen(true);
      return;
    }

    mutate(
      {
        title,
        content,
        isMobile: true,
        uuid: noticeDetail.uuid,
      },
      {
        onSuccess: (data) => {
          disableUnloadTracking();
          navigate(
            ROUTER_PATH.notice.dashboard.detail(data.data.result.notice.uuid),
          );
        },
      },
    );
  };

  useEffect(() => {
    (title.length > 0 || content.length > 0) && enableUnloadTracking();
    return () => disableUnloadTracking();
  }, [disableUnloadTracking, enableUnloadTracking, title.length, content]);

  const handleConfirmClick = () => {
    if (title.length > 100) {
      setNameErrorToastOpen(true);
    } else if (title.length === 0) {
      setIsNameEmptyOpen(true);
    } else if (!content) {
      setIsContentEmptyOpen(true);
    } else {
      setIsConfirmModal(true);
    }
  };

  return (
    <MobilePageCover
      header={
        <Link to={ROUTER_PATH.notice.dashboard._path}>
          <LeftIcon />
        </Link>
      }
    >
      <SaveWarningModal
        isOpen={isBlock}
        onConfirm={process}
        onCancel={blocking}
      />
      <Toast.Message
        open={nameErrorToastOpen}
        onOpenChange={setNameErrorToastOpen}
      >
        제목은 최대 100자까지 입력이 가능합니다.
      </Toast.Message>
      <Modal.Root open={isConfirmModal} onOpenChange={setIsConfirmModal}>
        <Modal.Body
          title="공지사항을 수정하시겠습니까?"
          onConfirm={handleSubmit}
          onCancel
        />
      </Modal.Root>
      <Modal.Root open={isNameEmptyOpen} onOpenChange={setIsNameEmptyOpen}>
        <Modal.Body title="제목 기입 필수" onConfirm>
          제목은 필수 항목 입니다. 제목 기입 후 다시 등록해 주세요.
        </Modal.Body>
      </Modal.Root>
      <Modal.Root
        open={isContentEmptyOpen}
        onOpenChange={setIsContentEmptyOpen}
      >
        <Modal.Body title="내용 기입 필수" onConfirm>
          내용은 필수 항목 입니다. 내용 기입 후 다시 등록해 주세요.
        </Modal.Body>
      </Modal.Root>

      <NoticeCreateMobileLayout>
        <h1>공지사항 수정</h1>

        <InfoListItem title="제목" direction="column">
          <NoticeCreateMobileInput
            placeholder="제목을 입력해주세요."
            value={title}
            onChange={(e) => {
              if (e.target.value.length > 100) {
                setNameErrorToastOpen(true);
              }
              setTitle(e.target.value);
            }}
          />
        </InfoListItem>

        <InfoListItem title="본문 내용" direction="column">
          <NoticeCreateMobileTextArea
            placeholder="본문 내용을 입력해주세요."
            value={content}
            onChange={(e) => {
              setContent(e.target.value);
            }}
          />
        </InfoListItem>

        <Button type="submit" onClick={handleConfirmClick}>
          수정
        </Button>
      </NoticeCreateMobileLayout>
    </MobilePageCover>
  );
};

export default NoticeDashboardEditMobilePage;

const NoticeCreateMobileLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.8rem;
  padding: 1.6rem;
  h1 {
    ${({ theme }) => theme.typography.t1.semibold};
  }
  height: 100%;
  flex: 1;
`;

const NoticeCreateMobileInput = styled.input`
  width: 100%;
  background-color: ${({ theme }) => theme.color.grey[200]};
  padding: 1.6rem 2rem;
  border-radius: 1rem;
  border: none;
`;

const NoticeCreateMobileTextArea = styled.textarea`
  width: 100%;
  background-color: ${({ theme }) => theme.color.grey[200]};
  padding: 1.6rem 2rem;
  border-radius: 1rem;
  border: none;

  height: 30rem;
`;
